exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host.hide-clock .cal {\n  margin-right: 15px; }\n\n:host.hide-clock .clock {\n  display: none; }\n\n.datepicker-wrapper {\n  margin-bottom: 0; }\n\n.cal {\n  float: right;\n  margin-top: -21px;\n  margin-right: 35px;\n  color: #5b6779;\n  cursor: pointer; }\n\n.clock {\n  float: right;\n  margin-top: -21px;\n  margin-right: 10px;\n  color: #5b6779; }\n\n.date-form {\n  padding: 0;\n  border: none; }\n\n::ng-deep .glyphicon {\n  color: #5059d3; }\n\n::ng-deep .bootstrap-datetimepicker-widget table td.active {\n  background-color: #5059d3;\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }\n\n::ng-deep .bootstrap-datetimepicker-widget table td.active:hover {\n  background-color: #5059d3;\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25); }\n\n::ng-deep .btn-primary {\n  color: #fff;\n  background-color: #5059d3;\n  border-color: #5059d3; }\n\n::ng-deep .btn-primary:hover {\n  color: #fff;\n  background-color: #5059d3;\n  border-color: #5059d3; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/date-time-picker/date-time-picker.component.scss
// module id = ../../../../../src/app/shared/components/date-time-picker/date-time-picker.component.scss
// module chunks = 12